import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SmsMessage, SmsMessageIgnoreList } from '../models/sms-message.model';
import { GenericBaseService } from './generic-base.service';
import { UrlService } from "./url.service";

@Injectable({
  providedIn: 'root'
})

export class SmsMessageService extends GenericBaseService {

  constructor(
    protected httpClient: HttpClient,
    protected toastrService: ToastrService,
    protected url: UrlService
  ) {
    super('Sms Message', httpClient, toastrService, url);
  }

  postSmsMessage(smsMessage: SmsMessage, afterPostCallback?: Function, addedMessage?: string, addedAndSendMessage?: string) {
    this.post('/sms-message', this.getBody(smsMessage, SmsMessageIgnoreList))
      .subscribe(
        (postedSmsMessage: SmsMessage) => {
          if (afterPostCallback) {
            afterPostCallback();
          }

          if (postedSmsMessage.HasError) {
            this.toastrService.warning(postedSmsMessage.ErrorMessage);
            this.toastrService.success(addedMessage);
          } else {
            this.toastrService.success(addedAndSendMessage);
          }
        });
  }

  sendSmsMessage(smsMessage: SmsMessage, afterPostCallback?: Function, customMessage?: string) {
    return this.postNow('/sms-message/send', this.getBody(smsMessage, SmsMessageIgnoreList), afterPostCallback, customMessage);
  }
}
